<template>
  <div
    class="productCard container mb-2 pt-2"
    v-if="browserSize === `mobile`"
    elevation="0"
  >
    <div style="height: 100%">
      <div class="proCol">
        <img
          class="item-picture"
          :src="
            theProduct.image != null
              ? theProduct.image
              : '/assets/site/images/express.png'
          "
          alt="picture"
        />
      </div>
      <div class="">
        <div class="text-center">
          <span class="product-title my-title mb-2 mt-2 d-inline-block">{{
            theProduct.name
          }}</span>
          <div>
            <div class="my-title-3 mb-4">
              <span class="mx-1">
                {{
                  modifyNumber(
                    (
                      theProduct.price -
                      (theProduct.price * theProduct.discount) / 100
                    ).toFixed()
                  )
                }}
                تومان
              </span>
              <span
                v-if="theProduct.discount && theProduct.discount !== 0"
                style="text-decoration: line-through"
                >{{ modifyNumber(theProduct.price) }} تومان
              </span>
            </div>
            <div class="clearfix py-1 px-2">
              <div @click="editMe" class="edit left">
                <img src="/assets/site/images/seller-icons/edit.svg" />
              </div>
              <div class="right">
                <div v-if="enabled" class="mb-1" style="color: #74bdb8">
                  موجود
                </div>
                <div v-else class="text-color mb-1 ml-2">ناموجود</div>
                <div @click="changeRemain">
                  <v-switch color="#93f2eb" v-model="enabled" inset></v-switch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageIcon from "../../../Common/icon";
import Switches from "vue-switches";
import Discount from "../../../Main/Layout/Discount";
import Service from "../../../../utils/seller-service";

export default {
  name: "productItemMobileView",
  props: ["theProduct", "browserSize"],
  components: {
    Discount,
    ImageIcon,
    Switches,
  },
  methods: {
    modifyNumber(n) {
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    deleteMe: function () {
      this.$emit("deleteMe", this.theProduct.id);
    },
    editMe: function () {
      this.$router.push("/seller/product/" + this.theProduct.id);
    },
    changeRemain() {
      let f = new FormData();
      if (this.enabled) {
        f.append("status", 0);
      } else {
        f.append("status", 1);
      }
      console.log(f.get("status"));
      this.authService.transmit(
        "seller/product/" + this.theProduct.id,
        f,
        () => {
          alert("تغییرات ثبت شد");
        },
        (s, er) => {
          console.log({ er });
        }
      );
    },
    getProduct(id) {
      this.authService.receive(
        "seller/product/" + id,
        {},
        (s, d) => {
          console.log(d.data);
          this.focusedProduct = d.data.product;
        },
        (s, e) => {
          console.log("this is error", e);
        }
      );
    },
  },
  mounted() {
    if (this.theProduct.status === 1) {
      this.enabled = true;
    } else {
      this.enabled = false;
    }
  },
  data() {
    return {
      myOptions: {
        layout: {
          color: "black",
          backgroundColor: "lightgray",
          selectedColor: "white",
          selectedBackgroundColor: "green",
          borderColor: "black",
          fontWeight: "normal",
          fontWeightSelected: "bold",
          squareCorners: false,
          noBorder: false,
        },

        items: {
          delay: 0.4,
          preSelected: "unknown",
          disabled: false,
          labels: [
            { name: "ناموجود", color: "white", backgroundColor: "red" },
            { name: "موجود", color: "white", backgroundColor: "green" },
          ],
        },
      },
      enabled: true,
      focusedProduct: {},
    };
  },
  computed: {
    authService() {
      return Service(true);
    },
  },
};
</script>
<style lang="scss">
.vue-switcher-theme--bulma.vue-switcher-color--default div {
  background-color: rgb(50, 205, 192);
}

.vue-switcher-theme--bulma.vue-switcher-color--default.vue-switcher--unchecked
  div {
  background-color: #e8e8e8;
}
.productCard {
  .v-input--selection-controls {
    margin-top: 0;
  }
}
.products-page {
  .v-messages {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.item-picture {
  width: 100%;
}

.productCard {
  background-color: white;
  border-radius: 15px;
  // background-color: #fff9fd;
}

.actionIcon {
  width: 20px;
  height: 20px;
  margin-top: 20px;
}

.proCol {
  align-self: center;
  padding-right: 0px !important;
  padding-left: 0px !important;
  margin-bottom: 10px;
  img {
    width: 63%;
    margin: 0 auto;
    display: block;
    border-radius: 25px;
    max-height: 36vh;
    box-shadow: 0px 0px 4px #f7d9f1;
  }
}
.product-title {
}
.edit {
  width: 40px;
  height: 40px;
  margin-top: 15px;
  border-radius: 10px;
  // box-shadow: 0 0 3px #ffb9f9;
  padding-top: 3px;
  img {
    width: 80%;
  }
}
</style>